"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalisedOutreachService = void 0;
class PersonalisedOutreachService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get history of personalised outreach
     * @param channelId
     * @param campaignGroupId
     * @param deploymentId
     * @param page
     * @param count
     * @returns PersonalisedOutreachHistoryResponse
     * @throws ApiError
     */
    getPersonalisedOutreachHistory(channelId, campaignGroupId, deploymentId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/personalised-outreach/history',
            query: {
                'channelId': channelId,
                'campaignGroupId': campaignGroupId,
                'deploymentId': deploymentId,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Generate personalised outreach from channel and campaign description
     * @param requestBody
     * @returns GeneratePersonalisedOutreachResponse
     * @throws ApiError
     */
    generatePersonalisedOutreachFromCreator(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/personalised-outreach/channel',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate personalised outreach from a prompt
     * @param requestBody
     * @returns GeneratePersonalisedOutreachResponse
     * @throws ApiError
     */
    generatePersonalisedOutreachFromPrompt(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/personalised-outreach/prompt',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get allowed prompt template variables
     * @returns PromptVariablesResponse
     * @throws ApiError
     */
    getAllowedPromptTemplateVariables() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/personalised-outreach/variables',
        });
    }
}
exports.PersonalisedOutreachService = PersonalisedOutreachService;
